export const wishlistActions = {
    LOADING: 'LOADING',
    ERROR: 'ERROR',
    GET_WISHLIST_ITEMS: 'GET_WISHLIST_ITEMS',
    REMOVE_WISHLIST_ITEM: 'REMOVE_WISHLIST_ITEM',
    ADD_WISHLIST_ITEM: 'ADD_WISHLIST_ITEM',
}
